export default __webpack_public_path__ + "static/media/Threejs_101.8e7e61e3.webp";